/**
 * 字符串相关处理类
 * @class UtilString
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.string.getNumString(10000);
 */
class UtilString {
  /**
   * '@'字符串过滤器
   * @param {String} input 输入字符串
   * @returns {String} 处理后字符串
   * @method
   */
  atFilter(input) {
    let ret = input || '';
    /*eslint-disable */
    const reg = /(?:@\{uid:(\w+)\s*,\s*nick:(.*?)(?:\s*,\s*who:(\d))?(?:\s*,\s*auto:(\d))?\})|(?:\[em\]e(\d{1,7})\[\/em\])|(?:#([^#]+)?#)|($)/gim;

    input.replace(reg, (
      curr,
      uid,
      nick,
      who,
      auto,
      face,
      topic,
      end,
      index,
      input,
    ) => {
      if (uid) {
        try {
          nick = decodeURIComponent(nick);
        } catch (err) {
          nick = '(null)'; // 和客户端一致
        }
        const node = `@${nick}`;
        ret = ret.replace(curr, node);
      }
    });

    return ret;
  }

  /**
   * 获取数字的字符串表示
   * @example 例:
   * // return '3.8万'
   * getNumString(38000, {unitType: 'cn'});
   * @param {Number|String} number 数字
   * @param {Object} option 选项
   * @param {String} option.unitType 单位语言
   * @returns {String} 字符串
   * @method
   */
  getNumString(number, option) {
    const num = parseInt(number) || 0;
    const opt = option || {};
    if (opt.unitType != 'en') {
      opt.unitType = 'cn';
    }
    if (num >= 100000000) {
      return (Math.round(num / 10000000) / 10).toFixed(1) + (opt.unitType == 'en' ? 'e' : '亿');
    }
    if (num >= 10000) {
      return (Math.round(num / 1000) / 10).toFixed(1) + (opt.unitType == 'en' ? 'w' : '万');
    }
    return String(num);
  }

  /**
   * 简单模板处理
   * @param {String} str
   * @param {Object} data
   * @returns {String}
   * @example 例
   * 例如传入'{{nick}}_hello', { nick: 'Alex' }，输出Alex_hello
   * @method
   */
  simpleTemplate(str, data) {
    if (!str || !data) {
      return str;
    }

    return str.replace(/{{\w+}}/g, (match) => {
      const m = match.replace(/[{|}]/g, '');
      return typeof data[m] === 'undefined' ? '' : data[m];
    });
  }
}

export default new UtilString();
